import { FeatureProduct, FeatureSubscription } from './types';

function getPaymentsApiUrl() {
  const url = process.env.REACT_APP_PAYMENTS_API_URL;
  if (!url) {
    throw new Error('Payment API URL is not configured. Please check your environment variables.');
  }
  return url;
}

async function parseError(response: Response) {
  try {
    const errorData = await response.json();
    return errorData.error || `HTTP error! status: ${response.status}`;
  } catch {
    return `HTTP error! status: ${response.status}`;
  }
}

export async function fetchFeatureCatalog(): Promise<FeatureProduct[]> {
  const response = await fetch(`${getPaymentsApiUrl()}/feature-products`);
  if (!response.ok) {
    throw new Error(await parseError(response));
  }
  const data = await response.json();
  return data.products ?? [];
}

export async function fetchFeatureSubscriptions(email: string): Promise<FeatureSubscription[]> {
  const response = await fetch(`${getPaymentsApiUrl()}/subscriptions?email=${encodeURIComponent(email)}`);
  if (!response.ok) {
    throw new Error(await parseError(response));
  }
  const data = await response.json();
  return data.subscriptions ?? [];
}

export async function cancelFeatureSubscription(
  subscriptionId: string,
  email: string,
): Promise<FeatureSubscription> {
  const response = await fetch(`${getPaymentsApiUrl()}/subscriptions/cancel`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ subscriptionId, email }),
  });
  if (!response.ok) {
    throw new Error(await parseError(response));
  }
  const data = await response.json();
  return data.subscription;
}
